(function () {
  function getCartPageSectionId() {
    const cartItems = document.getElementById('main-cart-items');
    return cartItems && cartItems.dataset.id ? cartItems.dataset.id : null;
  }

  function getSectionIds() {
    const pageSection = getCartPageSectionId();
    if (pageSection) {
      return [pageSection, 'cart-icon-bubble'];
    }
    return ['cart-icon-bubble'];
  }

  function buildCartUpdateBody(fields) {
    const body = Object.assign({}, fields);
    const sectionIds = getSectionIds();
    if (sectionIds && sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  function isCartDiscountCode(d) {
    return d && d.target_type !== 'shipping_line' && d.type === 'discount_code';
  }

  function cartHasAttachedDiscountCode(data) {
    const codes = (data && data.discount_codes) || [];
    return codes.some((c) => c && c.code && c.applicable !== false);
  }

  function cartHasAutomaticDiscount(data) {
    const apps = (data && data.discount_applications) || [];
    return apps.some(
      (d) =>
        d &&
        d.target_type !== 'shipping_line' &&
        d.total_allocated_amount > 0 &&
        (d.type === 'automatic' || d.type === 'script')
    );
  }

  function cartHasActiveDiscount(data) {
    if (!data) return false;
    if (typeof data.total_discount === 'number' && data.total_discount > 0) return true;
    const apps = data.discount_applications || [];
    return apps.some(
      (d) => d && d.target_type !== 'shipping_line' && d.total_allocated_amount > 0
    );
  }

  function fetchFreshCart() {
    return fetch('/cart.js?_t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }

  function clearCartDiscountCodes() {
    const body = buildCartUpdateBody({ discount: '' });
    return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    }).then((res) => res.json());
  }

  /** True when Shopify accepted the code (discount_codes or discount_applications). */
  function discountLooksApplied(data, code) {
    const needle = String(code || '').trim().toLowerCase();
    if (!needle) return false;

    const codes = (data && data.discount_codes) || [];
    if (
      codes.some(
        (c) => c && c.code && c.code.toLowerCase() === needle && c.applicable !== false
      )
    ) {
      return true;
    }

    const apps = (data && data.discount_applications) || [];
    if (
      apps.some((d) => {
        if (!d || d.target_type === 'shipping_line') return false;
        if (!d.total_allocated_amount || d.total_allocated_amount <= 0) return false;
        const title = String(d.title || '').toLowerCase();
        return title === needle;
      })
    ) {
      return true;
    }

    const levelApps = (data && data.cart_level_discount_applications) || [];
    return levelApps.some((d) => {
      if (!d || d.target_type === 'shipping_line') return false;
      const title = String(d.title || d.code || '').toLowerCase();
      return title === needle;
    });
  }

  function refreshCartPageFromSections(sections) {
    const sectionId = getCartPageSectionId();
    if (!sectionId || !sections || !sections[sectionId]) return false;

    const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    const root = doc.querySelector('.shopify-section') || doc;
    const sourceItems = root.querySelector('#main-cart-items .js-contents') || root.querySelector('.js-contents');
    const liveItems = document.querySelector('#main-cart-items .js-contents');
    if (sourceItems && liveItems) {
      liveItems.innerHTML = sourceItems.innerHTML;
    }

    const sourceFooter =
      root.querySelector('#main-cart-footer .js-contents-footer') || root.querySelector('.js-contents-footer');
    const liveFooter = document.querySelector('#main-cart-footer .js-contents-footer');
    if (sourceFooter && liveFooter) {
      liveFooter.innerHTML = sourceFooter.innerHTML;
    }

    const page = document.getElementById('VrvCartPage');
    if (page) {
      const hasLines = liveItems && (liveItems.querySelector('.vrv-cart-line') || liveItems.querySelector('.vrv-cart-page__lines'));
      page.classList.toggle('vrv-cart-page--empty', !hasLines);
      page.classList.toggle('is-empty', !hasLines);
    }

    return true;
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  function updateCartIconBubble(html) {
    const iconEl = document.getElementById('cart-icon-bubble');
    if (!iconEl || !html) return false;

    let nextHtml = getSectionInnerHTML(html);
    if (!nextHtml) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section =
        doc.querySelector('#shopify-section-cart-icon-bubble') ||
        doc.querySelector('[id^="shopify-section-"]');
      if (section) nextHtml = section.innerHTML;
    }
    if (!nextHtml) nextHtml = html;

    if (nextHtml) {
      iconEl.innerHTML = nextHtml;
      return true;
    }
    return false;
  }

  function fetchCartIconBubbleSection() {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(`${cartUrl}?section_id=cart-icon-bubble`, {
      method: 'GET',
      headers: { Accept: 'text/html' },
      cache: 'no-store',
    })
      .then((res) => (res.ok ? res.text() : ''))
      .then((html) => updateCartIconBubble(html))
      .catch(() => false);
  }

  function refreshCartFromResponse(data) {
    const cartPageUpdated = data && data.sections && refreshCartPageFromSections(data.sections);
    if (cartPageUpdated) bindExtras(document.getElementById('VrvCartPage') || document);

    const bubbleHtml = data && data.sections && data.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      updateCartIconBubble(bubbleHtml);
    } else if (data && (typeof data.item_count === 'number' || Array.isArray(data.items))) {
      fetchCartIconBubbleSection();
    }
  }

  async function copyDiscountCode(code, btn) {
    const raw = typeof code === 'string' ? code.trim() : '';
    if (!raw) return;
    const text = raw.toUpperCase();
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(text);
      } else {
        const input = document.createElement('input');
        input.value = text;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      if (btn) {
        const old = btn.textContent;
        btn.textContent = 'Copied';
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.textContent = old;
          btn.classList.remove('is-copied');
        }, 1200);
      }
    } catch (_) {
      /* no-op */
    }
  }

  window.vrvFetchCartIconBubble = fetchCartIconBubbleSection;

  function getCouponErrorEl() {
    return document.getElementById('CartPage-CouponError');
  }

  function getCouponInputEl() {
    return document.getElementById('CartPage-CouponInput');
  }

  function showCouponError(message, sourceBtn) {
    if (sourceBtn) {
      const card = sourceBtn.closest('.vrv-offer-card');
      if (card) {
        card.classList.add('has-error');
        clearTimeout(card._vrvErrTimer);
        card._vrvErrTimer = setTimeout(() => card.classList.remove('has-error'), 1800);
      }
    }

    const errorEl = getCouponErrorEl();
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      clearTimeout(errorEl._vrvHideTimer);
      errorEl._vrvHideTimer = setTimeout(() => {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }, 5000);
    }
  }

  function clearCouponErrors() {
    const errorEl = getCouponErrorEl();
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
    clearTimeout(errorEl._vrvHideTimer);
  }

  function showAppliedCouponRow(code, sourceBtn) {
    if (!sourceBtn || !code) return;
    const inputRow = sourceBtn.closest('.vrv-drawer__coupon-input-row, .vrv-cart-page__promo-input-wrap');
    if (!inputRow) return;

    const isPage = inputRow.classList.contains('vrv-cart-page__promo-input-wrap');
    const upper = String(code).trim().toUpperCase();
    const applied = document.createElement('div');
    applied.setAttribute('data-vrv-coupon-applied', '');

    if (isPage) {
      applied.className = 'vrv-cart-page__coupon-applied vrv-cart-page__coupon-applied--inline';
    } else {
      applied.className = 'vrv-drawer__coupon-applied vrv-drawer__coupon-applied--inline';
    }

    const icon = document.createElement('span');
    icon.className = isPage ? 'vrv-cart-page__coupon-applied-icon' : 'vrv-drawer__coupon-applied-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    const info = document.createElement('div');
    info.className = isPage ? 'vrv-cart-page__coupon-applied-info' : 'vrv-drawer__coupon-applied-info';

    const head = document.createElement('div');
    head.className = isPage ? 'vrv-cart-page__coupon-applied-head' : 'vrv-drawer__coupon-applied-head';

    const badge = document.createElement('span');
    badge.className = isPage
      ? 'vrv-cart-page__coupon-applied-badge vrv-cart-page__coupon-applied-badge--manual'
      : 'vrv-drawer__coupon-applied-badge vrv-drawer__coupon-applied-badge--manual';
    badge.textContent = 'Applied';

    const codeEl = document.createElement('span');
    codeEl.className = isPage ? 'vrv-cart-page__coupon-applied-code' : 'vrv-drawer__coupon-applied-code';
    codeEl.textContent = upper;

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = isPage ? 'vrv-cart-page__coupon-remove-btn' : 'vrv-drawer__coupon-remove-btn';
    removeBtn.setAttribute('data-vrv-remove-discount', '');
    removeBtn.setAttribute('aria-label', 'Remove coupon');
    removeBtn.textContent = 'Remove';

    head.appendChild(badge);
    head.appendChild(codeEl);
    info.appendChild(head);
    applied.appendChild(icon);
    applied.appendChild(info);
    applied.appendChild(removeBtn);

    const promo = inputRow.closest('.vrv-cart-page__promo');
    if (promo) {
      const barCopy = promo.querySelector('.vrv-cart-page__promo-bar-copy');
      if (barCopy) barCopy.style.display = 'none';
      const label = promo.querySelector('.vrv-cart-page__promo-label');
      if (label) label.style.display = 'none';
    }

    const err = inputRow.nextElementSibling;
    if (err && (err.classList.contains('vrv-drawer__coupon-error') || err.classList.contains('vrv-cart-page__promo-error'))) {
      err.hidden = true;
      err.textContent = '';
    }

    inputRow.replaceWith(applied);
    removeBtn.addEventListener('click', removeDiscount);
  }

  function applyDiscount(code, sourceBtn) {
    clearCouponErrors();

    if (!code || !String(code).trim()) {
      showCouponError('Please enter a coupon code', sourceBtn);
      return Promise.resolve();
    }

    const trimmed = String(code).trim();

    if (sourceBtn && trimmed.toUpperCase().startsWith('VRVCMBO_')) {
      showCouponError('This combo offer is applied automatically and cannot be added manually.', sourceBtn);
      return Promise.resolve();
    }

    if (typeof window.vrvClearAllDismissedDiscounts === 'function') {
      window.vrvClearAllDismissedDiscounts();
    } else {
      clearDismissedDiscount(trimmed);
    }
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem('vrvAutoApplyBlocked:' + trimmed);
      }
    } catch (_) {}

    if (sourceBtn) {
      sourceBtn.dataset.vrvOriginalLabel = sourceBtn.textContent.trim();
      sourceBtn.setAttribute('aria-busy', 'true');
      sourceBtn.disabled = true;
      sourceBtn.textContent = 'Applying…';
    }

    const restoreButton = () => {
      if (!sourceBtn) return;
      sourceBtn.removeAttribute('aria-busy');
      sourceBtn.disabled = false;
      if (sourceBtn.dataset.vrvOriginalLabel) {
        sourceBtn.textContent = sourceBtn.dataset.vrvOriginalLabel;
        delete sourceBtn.dataset.vrvOriginalLabel;
      }
    };

    return clearCartDiscountCodes()
      .then(() =>
        fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(buildCartUpdateBody({ discount: trimmed })),
        })
      )
      .then((res) => res.json().then((data) => ({ data, ok: res.ok, status: res.status })))
      .then(({ data, ok, status }) => {
        if (!ok || (data && data.status && data.message)) {
          const msg =
            (data && (data.description || data.message)) ||
            (status === 422 ? `Coupon "${trimmed}" could not be applied. Check minimum cart value or expiry.` : 'Invalid coupon code. Please try again.');
          showCouponError(msg, sourceBtn);
          restoreButton();
          return;
        }

        if (!discountLooksApplied(data, trimmed)) {
          const codes = (data && data.discount_codes) || [];
          const codeEntry = codes.find((c) => c && c.code && c.code.toLowerCase() === trimmed.toLowerCase());
          const msg =
            codeEntry && codeEntry.applicable === false
              ? `"${trimmed}" is not applicable to this cart (minimum value, expiry or eligibility).`
              : `Coupon "${trimmed}" could not be applied.`;
          showCouponError(msg, sourceBtn);
          restoreButton();
          return;
        }

        couponApplyCooldownUntil = Date.now() + 4000;

        try {
          if (window.sessionStorage) {
            window.sessionStorage.setItem('vrvPreferredCoupon', trimmed.toUpperCase());
          }
        } catch (_) {}

        refreshCartFromResponse(data);
        bindExtras(document.getElementById('VrvCartPage') || document, { skipAutoApply: true });

        fetchFreshCart().then((fresh) => {
          if (fresh && typeof window.vrvSyncCartPricingUI === 'function' && cartHasActiveDiscount(fresh)) {
            window.vrvSyncCartPricingUI(fresh);
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon', cartData: data });
        }
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: Object.assign({}, data, { source: 'cart-coupon' }) })
        );
      })
      .catch(() => {
        showCouponError('Could not connect. Please check your network and try again.', sourceBtn);
        restoreButton();
      });
  }

  /** Read the codes currently shown as "applied" inside the cart drawer / page.
   *  Optionally narrow to a specific Remove button's surrounding container so the
   *  cart-page markup (no dedicated code class) is handled too. */
  function getDisplayedAppliedCodes(scopeBtn) {
    const codes = new Set();

    const harvestFrom = (root) => {
      if (!root) return;
      const codeEl = root.querySelector('.vrv-drawer__coupon-applied-code, .vrv-cart-page__coupon-applied-code');
      if (codeEl) {
        (codeEl.textContent || '').split(',').forEach((raw) => {
          const code = raw.trim();
          if (code) codes.add(code);
        });
        return;
      }
      // Fallback: the cart-page snippet just prints <strong>{{ discount.title }}</strong>.
      const fallbackEl = root.querySelector('strong');
      if (fallbackEl) {
        const code = (fallbackEl.textContent || '').trim();
        if (code) codes.add(code);
      }
    };

    if (scopeBtn) {
      harvestFrom(scopeBtn.closest('.vrv-drawer__coupon-applied, .vrv-page-offers__applied') || document);
    } else {
      document
        .querySelectorAll('.vrv-drawer__coupon-applied, .vrv-page-offers__applied')
        .forEach(harvestFrom);
    }
    return Array.from(codes);
  }

  /** Mark a code as user-removed so the auto-apply loop won't immediately re-attach it. */
  function blockAutoApplyForCode(code) {
    if (!code) return;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('vrvAutoApplyBlocked:' + code, '1');
        // Also keep the "already tried" flag so the existing guard fires too.
        window.sessionStorage.setItem('vrvAutoApply:' + code, '1');
      }
    } catch (_) {}
  }

  /**
   * Theme-settings-driven private/hidden codes (window.vrvHiddenCodes is set
   * once in layout/theme.liquid). Used to gate auto-apply attempts so a hidden
   * code can never be silently re-attached by our scripts. Hidden codes can
   * still be applied when the customer manually types them — Shopify itself
   * validates the code against the Admin → Discounts list at checkout.
   */
  function isHiddenCode(code) {
    if (!code) return false;
    try {
      const map = window.vrvHiddenCodes || {};
      return !!map[String(code).trim().toLowerCase()];
    } catch (_) {
      return false;
    }
  }

  /**
   * Per-session list of discount codes the customer has explicitly dismissed
   * via the cart "Remove" button. Used to visually hide the applied-coupon
   * card even when Shopify automatically re-attaches the discount (true
   * "Automatic Discounts" created in Admin → Discounts → Automatic, or
   * codes re-applied by a third-party app / URL param like ?discount=).
   *
   * This is a UI-only hide — the discount itself may still apply at checkout
   * if Shopify enforces it. The small "auto-applied at checkout" note below
   * the input keeps the customer informed.
   */
  const DISMISSED_KEY = 'vrvDismissedDiscounts';

  function getDismissedDiscounts() {
    try {
      if (!window.sessionStorage) return new Set();
      const raw = window.sessionStorage.getItem(DISMISSED_KEY) || '[]';
      const arr = JSON.parse(raw);
      return new Set(Array.isArray(arr) ? arr.map((c) => String(c).toUpperCase()) : []);
    } catch (_) {
      return new Set();
    }
  }

  function saveDismissedDiscounts(set) {
    try {
      if (!window.sessionStorage) return;
      window.sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(Array.from(set)));
    } catch (_) {}
  }

  function addDismissedDiscount(code) {
    if (!code) return;
    const set = getDismissedDiscounts();
    set.add(String(code).toUpperCase());
    saveDismissedDiscounts(set);
  }

  function clearDismissedDiscount(code) {
    if (!code) return;
    const set = getDismissedDiscounts();
    if (set.delete(String(code).toUpperCase())) saveDismissedDiscounts(set);
  }

  /**
   * After every cart refresh, walk the applied-coupon cards and hide any
   * whose codes are in the dismissed set. We replace the card with the
   * normal coupon input so the customer can keep using the drawer.
   */
  function hideDismissedDiscountCards(scope) {
    const dismissed = getDismissedDiscounts();
    if (dismissed.size === 0) return;
    const root = scope || document;

    root.querySelectorAll('.vrv-drawer__coupon-applied').forEach((card) => {
      if (card.dataset.vrvHidden === '1') return;
      const codeEl = card.querySelector('.vrv-drawer__coupon-applied-code');
      if (!codeEl) return;
      const codes = (codeEl.textContent || '')
        .split(',')
        .map((c) => c.trim().toUpperCase())
        .filter(Boolean);
      if (codes.length === 0) return;
      const allDismissed = codes.every((c) => dismissed.has(c));
      if (!allDismissed) return;

      card.dataset.vrvHidden = '1';
      card.style.display = 'none';

      const offersRoot = card.closest('[data-vrv-cart-offers]') || card.parentElement;
      if (offersRoot && !offersRoot.querySelector('[data-vrv-dismissed-input]')) {
        const input = document.createElement('div');
        input.setAttribute('data-vrv-dismissed-input', '1');
        input.className = 'vrv-drawer__coupon-input-row';
        input.innerHTML = ''
          + '<span class="vrv-drawer__coupon-input-icon" aria-hidden="true">'
          +   '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b8770" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'
          +     '<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.83z"/>'
          +     '<line x1="7" y1="7" x2="7.01" y2="7"/>'
          +   '</svg>'
          + '</span>'
          + '<input type="text" id="CartPage-CouponInput" class="vrv-cart-page__promo-input" placeholder="Enter Coupon Code" autocomplete="off" autocapitalize="characters" spellcheck="false">'
          + '<button type="button" class="vrv-drawer__coupon-apply" data-vrv-apply-discount-input>Apply</button>';
        card.insertAdjacentElement('afterend', input);
      }
    });
  }

  function removeDiscount(evt) {
    if (evt && evt.currentTarget && evt.currentTarget.closest('cart-drawer')) {
      if (typeof window.vrvDrawerRemoveDiscount === 'function') {
        return window.vrvDrawerRemoveDiscount(evt);
      }
    }

    const btn = evt && evt.currentTarget;
    if (btn) {
      btn.dataset.vrvOriginalLabel = btn.textContent.trim();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = 'Removing…';
    }

    const restoreBtn = () => {
      if (!btn) return;
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.dataset.vrvOriginalLabel) {
        btn.textContent = btn.dataset.vrvOriginalLabel;
        delete btn.dataset.vrvOriginalLabel;
      }
    };

    const removedCodes = getDisplayedAppliedCodes(btn);
    removedCodes.forEach((code) => {
      blockAutoApplyForCode(code);
      addDismissedDiscount(code);
    });

    couponApplyCooldownUntil = Date.now() + 8000;

    if (btn) {
      const card = btn.closest('.vrv-drawer__coupon-applied, .vrv-page-offers__applied');
      if (card) card.style.opacity = '0.55';
    }

    return clearCartDiscountCodes()
      .then((data) => fetchFreshCart().then((fresh) => fresh || data))
      .then((data) => {
        refreshCartFromResponse(data);
        const page = getCartPageRoot();
        if (page) bindExtras(page, { skipAutoApply: true });
        hideDismissedDiscountCards(page || document);

        const codesGone = !cartHasAttachedDiscountCode(data);
        const discountGone = !cartHasActiveDiscount(data);

        if (discountGone) {
          removedCodes.forEach((code) => clearDismissedDiscount(code));
        } else if (codesGone) {
          showCouponError(
            cartHasAutomaticDiscount(data)
              ? 'This store promotion is applied automatically by Shopify and cannot be removed here. To disable it, turn off the matching Automatic Discount in Shopify Admin → Discounts.'
              : 'Discount is still active on this cart. If this is a store-wide automatic offer, disable it in Shopify Admin → Discounts.',
            btn
          );
        } else {
          showCouponError('Could not remove the coupon. Please try again.', btn);
        }

        if (!cartHasAttachedDiscountCode(data) && typeof window.vrvSyncCartDisplayWithoutCoupon === 'function') {
          window.vrvSyncCartDisplayWithoutCoupon(data);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-coupon-remove', cartData: data });
        }
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: Object.assign({}, data, { source: 'cart-coupon-remove' }),
          })
        );
        restoreBtn();
      })
      .catch(() => {
        showCouponError('Could not remove the coupon. Please try again.', btn);
        restoreBtn();
      });
  }

  function handleRecAdd(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    if (typeof window.vrvAddToCart === 'function') {
      window.vrvAddToCart(variantId, btn, 'vrv-rec-card');
    }
  }

  function readWishlistFromStorage() {
    try {
      const raw = JSON.parse(localStorage.getItem('wishlist') || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (_) {
      return [];
    }
  }

  function saveWishlistToStorage(items) {
    try {
      localStorage.setItem('wishlist', JSON.stringify(items));
    } catch (_) {}
  }

  function addToWishlistFromCartButton(btn) {
    const handle = btn?.dataset?.productHandle;
    if (!handle) return false;

    const line = btn.closest('.cart-item, .vrv-cart-line');
    const qtyInput = line && line.querySelector('.quantity__input[data-quantity-variant-id]');
    const variantId = qtyInput ? qtyInput.getAttribute('data-quantity-variant-id') : '';
    const title = btn?.dataset?.productTitle || '';
    const url = btn?.dataset?.productUrl || '';

    const wishlist = readWishlistFromStorage();
    const exists = wishlist.some((item) => item && item.handle === handle);
    if (!exists) {
      wishlist.push({ handle, variantId, title, url });
      saveWishlistToStorage(wishlist);
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
    return true;
  }

  function removeCartLineForSaveLater(btn) {
    const line = btn.closest('.cart-item, .vrv-cart-line');
    if (!line) return false;

    const qtyInput = line.querySelector('.quantity__input[data-index]');
    const lineIndex = qtyInput && qtyInput.dataset ? qtyInput.dataset.index : null;
    const cartItems = line.closest('cart-items');
    if (!lineIndex || !cartItems || typeof cartItems.updateQuantity !== 'function') return false;

    cartItems.updateQuantity(lineIndex, 0);
    return true;
  }

  function handleSaveForLater(btn) {
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const oldLabel = btn.textContent;
    btn.textContent = 'Saving...';

    const saved = addToWishlistFromCartButton(btn);
    const removed = removeCartLineForSaveLater(btn);

    if (saved && removed) {
      btn.classList.add('is-saved');
      return;
    }

    btn.disabled = false;
    btn.textContent = oldLabel || 'Save for later';
  }

  /**
   * Auto-apply eligible coupon — triggers /cart/update.js with the discount code
   * for the single offer card marked with data-vrv-auto-apply="1".
   *
   * Guards:
   *  - Skips if the code was already attempted this session (avoids loop on failure)
   *  - Skips if any auto-apply card is already in a "Auto-Applied" visual state
   *  - Skips while a cart fetch is in flight
   */
  let autoApplyInFlight = false;
  function autoApplyEligibleDiscount(scope) {
    // Disabled: Do not auto-apply discount vouchers on page load/refresh without user action.
    return;
  }

  /** Clear auto-apply session flag if cart total drops below the offer's minimum
   *  (so the coupon can re-apply if user reaches the threshold again). */
  function clearAutoApplyFlagsOnRefresh(scope) {
    try {
      if (!window.sessionStorage) return;
      const root = scope || document;
      const allCards = root.querySelectorAll('[data-vrv-offer-card]');
      const eligibleAutoCodes = new Set();
      allCards.forEach((c) => {
        if (c.getAttribute('data-vrv-auto-apply') === '1') {
          const code = c.getAttribute('data-vrv-offer-code');
          if (code) eligibleAutoCodes.add(code);
        }
      });
      Object.keys(window.sessionStorage).forEach((key) => {
        if (key.indexOf('vrvAutoApply:') !== 0) return;
        const code = key.substring('vrvAutoApply:'.length);
        if (!eligibleAutoCodes.has(code)) {
          window.sessionStorage.removeItem(key);
        }
      });
    } catch (_) {}
  }

  function isDrawerScope(node) {
    return !!(node && node.closest && node.closest('cart-drawer'));
  }

  function getCartPageRoot() {
    return document.getElementById('VrvCartPage');
  }

  function bindExtras(root, options) {
    const opts = options || {};
    const scope = root || getCartPageRoot();
    if (!scope) return;

    scope.querySelectorAll('[data-vrv-apply-discount]').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyDiscount(btn.dataset.vrvApplyDiscount, btn);
      });
    });

    scope.querySelectorAll('[data-vrv-copy-discount]').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        copyDiscountCode(btn.dataset.vrvCopyDiscount, btn);
      });
    });

    if (!opts.skipAutoApply) {
      clearAutoApplyFlagsOnRefresh(scope);
      autoApplyEligibleDiscount(scope);
    }

    hideDismissedDiscountCards(scope);

    scope.querySelectorAll('[data-vrv-apply-discount-input]').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => {
        const input = getCouponInputEl();
        applyDiscount(input ? input.value : '', btn);
      });
    });

    scope.querySelectorAll('#CartPage-CouponInput').forEach((couponInput) => {
      if (couponInput.dataset.vrvBound) return;
      couponInput.dataset.vrvBound = 'true';
      couponInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const applyBtn = couponInput
            .closest('.vrv-drawer__coupon-input-row, .vrv-cart-page__promo-input-wrap')
            ?.querySelector('[data-vrv-apply-discount-input]');
          applyDiscount(couponInput.value, applyBtn);
        }
      });
    });

    scope.querySelectorAll('[data-vrv-remove-discount]').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', removeDiscount);
    });

    scope.querySelectorAll('.vrv-rec-card__add').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', () => handleRecAdd(btn));
    });

    scope.querySelectorAll('[data-vrv-save-later]').forEach((btn) => {
      if (isDrawerScope(btn)) return;
      if (btn.dataset.vrvBound) return;
      btn.dataset.vrvBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSaveForLater(btn);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const page = getCartPageRoot();
    if (page) bindExtras(page);
  });

  let qtyUpdateCooldownUntil = 0;
  let couponApplyCooldownUntil = 0;

  function scheduleBindExtrasAfterCartChange(options) {
    setTimeout(() => {
      if (document.getElementById('main-cart-items')?.classList.contains('cart__items--disabled')) return;
      const cartPage = getCartPageRoot();
      if (cartPage) bindExtras(cartPage, options);
    }, 0);
  }

  document.addEventListener('cart:line-updated', () => {
    qtyUpdateCooldownUntil = Date.now() + 2500;
    scheduleBindExtrasAfterCartChange({ skipAutoApply: true });
  });

  document.addEventListener('cart:updated', (e) => {
    if (e?.detail?.source === 'line-items') return;
    const skipAuto =
      e?.detail?.source === 'cart-coupon' ||
      e?.detail?.source === 'cart-coupon-remove' ||
      Date.now() < couponApplyCooldownUntil;
    scheduleBindExtrasAfterCartChange({ skipAutoApply: skipAuto });
  });

  /**
   * Auto-cleanup stale discount codes.
   *
   * Shopify keeps a discount code "attached" to the cart even after the cart
   * drops below the code's minimum cart value. In that state the code still
   * appears in `cart.discount_applications` with `total_allocated_amount = 0`,
   * which used to make the View All Offers panel show a stale "Applied" badge.
   *
   * We now skip 0-allocation entries in Liquid, but we also proactively detach
   * those codes from the cart so the next /cart.js call returns a clean state
   * (no ghost codes). When the customer adds items back above the threshold
   * they can re-apply the code fresh — matching the smooth Razorpay/Palmonas
   * flow the user expects.
   */
  let cartCleanupInFlight = false;
  let cartCleanupCooldownUntil = 0;
  function cleanupStaleDiscounts(detail) {
    if (cartCleanupInFlight) return;
    if (Date.now() < cartCleanupCooldownUntil) return;
    if (Date.now() < couponApplyCooldownUntil) return;
    if (detail && (detail.source === 'cart-coupon' || detail.source === 'cart-coupon-remove')) return;

    const inspect = (data) => {
      if (!data || !Array.isArray(data.discount_applications)) return;

      const codeApps = data.discount_applications.filter(isCartDiscountCode);
      if (codeApps.length === 0) return;

      const staleCodeApps = codeApps.filter((d) => !d.total_allocated_amount || d.total_allocated_amount <= 0);
      if (staleCodeApps.length === 0) return;

      cartCleanupInFlight = true;
      cartCleanupCooldownUntil = Date.now() + 4000;

      const activeCodes = codeApps
        .filter((d) => d.total_allocated_amount > 0 && d.title)
        .map((d) => d.title);

      const body = new URLSearchParams();
      body.append('discount', activeCodes.length > 0 ? activeCodes.join(',') : '');

      fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update.js'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body,
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((updated) => {
          cartCleanupInFlight = false;
          if (!updated) return;
          refreshCartFromResponse(updated);
        })
        .catch(() => {
          cartCleanupInFlight = false;
        });
    };

    if (detail && Array.isArray(detail.discount_applications)) {
      inspect(detail);
      return;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then(inspect)
      .catch(() => {});
  }

  document.addEventListener('cart:updated', (e) => {
    if (document.getElementById('main-cart-items')?.classList.contains('cart__items--disabled')) return;
    if (Date.now() < qtyUpdateCooldownUntil) return;
    cleanupStaleDiscounts(e && e.detail);
  });

  let bubbleRefreshTimer;
  document.addEventListener('cart:updated', (e) => {
    const detail = e && e.detail;
    if (!detail || detail.source === 'line-items') return;
    if (detail.sections && detail.sections['cart-icon-bubble']) return;
    clearTimeout(bubbleRefreshTimer);
    bubbleRefreshTimer = setTimeout(() => fetchCartIconBubbleSection(), 80);
  });

  const cartPage = document.getElementById('VrvCartPage');
  if (cartPage) {
    window.vrvBindCartExtras = (options) => bindExtras(cartPage, options);
  }
})();
